import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, CssBaseline, Toolbar } from '@mui/material';
import Navbar from '../Components/LandingComponent/Navbar'; // Adjust path if needed
import SideDrawer from '../Components/newcomponents/SideDrawer'; // Adjust path if needed
import MilestoneManager from './MilestoneManager'; // Adjust path if needed

const MilestonePage = () => {
  // Get the projectId from the URL
  const { projectId } = useParams();

  // Your handleLogout function (or import it)
  const handleLogout = () => {
    console.log("Logout");
    // Add your actual logout logic here
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Navbar handleLogout={handleLogout} />
      <SideDrawer projectId={projectId} />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        {/* Render the MilestoneManager and pass the projectId to it */}
        {projectId ? (
          <MilestoneManager projectId={projectId} />
        ) : (
          <p>Loading project...</p>
        )}
      </Box>
    </Box>
  );
};

export default MilestonePage;
